/* 毕业证明书 */ 
import Ajax from "./ajax";
import { jsToFormData } from "@/utils/func";

export const studentPaGetPost = data => Ajax.post(`/v1-student-pa-get-post`, jsToFormData(data));  // 申请数据提交
export const studentPaGet = data => Ajax.get(`/v1-student-pa-get`, data);  // 获取申请记录
